import React, { MouseEvent } from "react"

import { useLayerPopupContext } from "@shared/contexts"

function Confirm() {
  const { confirm, close } = useLayerPopupContext()

  return (
    <>
      <article
        className="popup"
        style={{ width: "230px", margin: "-250px 0 0 -115px" }}
      >
        <div className="titB">
          <a
            href="#!"
            title="닫기"
            onClick={(e) => {
              e.preventDefault()
              close()
            }}
          >
            닫기
          </a>
        </div>
        <div className="txtB">
          <div className="roundB">
            <p>{confirm.message}</p>
            {confirm?.confirmAction === undefined && (
              <p className="txt">
                ※ 시청자에게는 메시지가
                <br />
                보이지 않습니다.
              </p>
            )}
          </div>
        </div>
        <div className="btnB">
          <a
            href="#!"
            className="cancel"
            title="취소"
            onClick={(e: MouseEvent) => {
              e.preventDefault()
              close()
            }}
          >
            취소
          </a>
          <a
            href="#!"
            title="확인"
            onClick={(e: MouseEvent) => {
              e.preventDefault()
              if (confirm.confirmAction) {
                confirm.confirmAction()
              } else {
                confirm.handleConfirm({ ...confirm, isConfirm: true })
              }

              close()
            }}
          >
            확인
          </a>
        </div>
      </article>
    </>
  )
}

export default Confirm
